import {ngAsync} from 'shared/utils/ng-@decorators';
import type {ServerFolder} from 'typings/portaro.be.types';
import type FinishedResponseInteractionService from '../../commons/services/finished-response-interaction.service';
import type ReportServerDataService from './report-server.data-service';

/**
 * @ngdoc service
 * @name reportServerService
 * @module use-cases.report-server
 *
 * @requires Restangular
 *
 * @description
 * Service for interaction with report-server
 */

export default class ReportServerService {
    public static serviceName = 'reportServerService';

    /*@ngInject*/
    constructor(private reportServerDataService: ReportServerDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async getServerFolder(): Promise<ServerFolder> {
        try {
            return await this.reportServerDataService.getServerFolder();
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }


}
